
import {
  defineComponent,
  ref,
  computed,
  PropType,
} from 'vue';
import { _CreatedApp } from '../composables/useAppInfo';
import type {
  IAppInfoItem,
} from '@/api/manage-app/app-manage/index.d';

export default defineComponent({
  name: 'DisabledApp',
  emits: ['update:visible', 'handleSearch'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    accountAppItem: {
      type: Object as PropType<IAppInfoItem>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const disabledVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });
    const formData = ref({
      remark: '', // 备注
    });

    const {
      handleDisClose,
      handleDisSave,
    } = _CreatedApp(
      formData,
      emit as any,
    );

    return {
      formData,
      disabledVisible,
      rules: {
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' },
        ],
      },
      handleDisClose,
      handleDisSave,
    };
  },
});
